import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import * as cls from "./modalChangeDiscip.module.scss";
import { Icon } from "../../../personal-studio-components/frame";
import { StudentService } from "../studentService";
import { Button } from "../../../personal-studio-components/form";
function ModalChangeDiscip({
  isShowModal,
  setIsShowModal,
  elective,
  access_token,
  contractId,
  getLinegraph,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedDiscip, setSelectedDiscip] = useState(null);
  const handleChangeElectiveDiscip = async (e, id, idx) => {
    const request = {
      method: "post",
      path: "/student/linegraph/change_elective_discip",
      data: {
        access_token,
        study_contract_id: contractId,
        ind_mod_discip_id: id,
      },
    };
    setSelectedDiscip(idx);
    e.stopPropagation();
    await StudentService.send(request, (response) => {});
    await getLinegraph();
    setSelectedDiscip(null);
  };
  const handleClose = (e) => {
    e.stopPropagation();
    setIsShowModal(false);
  };
  return (
    <Dialog
      fullScreen={fullScreen}
      open={isShowModal}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      classes={{ paper: cls.dialog_paper }}
    >
      <DialogTitle>
        <Icon name="info" className={cls.icon} /> Сменить выбранную дисциплину
      </DialogTitle>

      <Box>
        {elective.map((discip, idx) => (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <DialogContent>{discip.name}</DialogContent>
            <div>
              {discip.is_selected ? (
                <Button type="primary" onClick={handleChangeElectiveDiscip}>
                  Выбрано
                </Button>
              ) : (
                <Button
                  onClick={(e) =>
                    handleChangeElectiveDiscip(e, discip.ind_mod_discip_id, idx)
                  }
                >
                  {selectedDiscip === idx ? <Icon name="loading" /> : "Сменить"}
                </Button>
              )}
            </div>
          </div>
        ))}
      </Box>
      <Divider />
      <div className={cls.btnContainer}>
        <Button onClick={handleClose}>Закрыть</Button>
      </div>
    </Dialog>
  );
}

export default ModalChangeDiscip;
